import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/expediaActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchExpediaOrganizations = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.EXPEDIA_ORGANIZATIONS_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.expediaOrganizations, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.expedia_fetchOrganizationsSuccess(getParser(urls.expediaOrganizations)(json))))
        .catch(
            handleError(
                dispatch,
                actions.expedia_fetchOrganizationsFailure,
                'Что-то пошло не так!',
                'При получении организаций произошла ошибка'
            )
        )
}

/** @thunk **/
export const postExpediaOrganization = organization => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(organization)
    }
    const { auth } = getState()

    securedFetch(urls.expediaOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.expedia_saveOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация добавлена'))
        .catch(
            handleError(
                dispatch,
                actions.expedia_saveOrganizationsFailure,
                'Что-то пошло не так!',
                'При сохранении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const updateExpediaOrganization = (remoteId, payload) => (dispatch, getState) => {
    // prettier-ignore
    const { auth, expediaOrganizations: { entities: { organizations } } } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...organizations[remoteId], ...payload })
    }

    securedFetch(urls.expediaOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.expedia_updateOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация обновлена'))
        .catch(
            handleError(
                dispatch,
                actions.expedia_updateOrganizationsFailure,
                'Что-то пошло не так!',
                'При обновлении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteExpediaOrganization = remoteId => (dispatch, getState) => {
    const { auth } = getState()
    securedFetch(urls.expediaOrganizationSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.expedia_deleteOrganizationSuccess(remoteId)))
        .then(() => toastr.success('Организация удалена'))
        .catch(
            handleError(
                dispatch,
                actions.expedia_deleteOrganizationFailure,
                'Что-то пошло не так!',
                'При удалении организации произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/expediaApi/expediaOrganizations.js